import { Accordion, Grid, Segment } from 'semantic-ui-react'
import styled from 'styled-components'

export const StyledSegment = styled(Segment)`
background: white !important;
-webkit-box-shadow: none !important;
background-color: rgb(241 245 249) !important;
border: none !important;
margin-bottom: 2em !important;
border-radius: 1.3rem !important;
min-height: auto !important;
box-shadow: none !important;
padding-bottom: 15px !important;
 .column {
  -webkit-box-shadow: none !important;  
   box-shadow: none !important;
 }
 .header {
  font-size: 18px !important;
 }
 .row {
  flew-wrap: no-wrap !important;
 }
`
export const StyledGrid = styled(Grid)`
 padding: 15px !important;
 .column-value {
  font-weight: bold !important;
 }
`
export const TableWrapper = styled.div`
position: relative;
min-height: 300px;
 .table-header {
  font-size: 15px !important;
  margin: 2em 0em 1em 0em;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 10px;
 }
`
export const FarmersSegment = styled.div`
 .table-header {
  font-size: 15px !important;
  margin: 2em 0em 1em 0em;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 10px;
 }
`
export const CustomRow = styled(Grid.Row)`
  flex-wrap: nowrap !important; /* Apply the desired flex-wrap value */
`;

export const StyledAccordion = styled(Accordion)`
width: 100% !important;
margin-top: 15px;
 .title {
   display: flex;
   align-items: baseline;
   justify-content: space-between;
   color: black !important;
 }
`